export const packageLengthRule = {
  type: "custom",
  validationCallback: () => true,
};
